export default __webpack_public_path__ + "static/media/text.759ad80a.svg";